<template>
    <div id="printableArea">
        <div class="container-fluid pt-4" dir="rtl">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-3"></div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                    <button class="bg-warning btn no-print mb-2 mr-2  text-light Pointer float-left "
                        @click="$router.go(-1)"> بازگشت </button>

                    <button class="bg-success btn no-print mb-2 text-light Pointer float-left " @click="GetPrint()"> چــاپ
                    </button>

                </div>
            </div>
            <table width="100%" class="table table-bordered border-dark text-center">
                <thead class="align-middle">
                    <tr>
                        <th colspan="12">
                            <div class="mb-1">
                                {{ DataAxios.WorkshopName }}
                            </div>
                            <div class="mb-1">

                                لیست بیمه تامین اجتماعی
                                {{ DataAxios.Month }}&nbsp;{{ DataAxios.Year }}

                            </div>
                            <div class="mb-1">
                                شعبه سازمان تامین اجتماعی
                            </div>
                            <div class="mb-1">
                                کد کارگاه {{ DataAxios.WorkshopCode }}
                            </div>
                        </th>
                    </tr>
                    <tr style="background-color: rgb(245, 245, 245);">
                        <td width="12%">
                            ردیف
                        </td>
                        <td width="6%">
                            نام پدر
                        </td>
                        <td width="8%">
                            کد کارمند
                        </td>
                        <td width="10%">
                            شغل
                        </td>
                        <td width="8%">
                            تاریخ شروع کار
                        </td>
                        <td width="6%">
                            ملیت
                        </td>
                        <td width="6%">
                            کارکرد
                        </td>
                        <td width="8%">
                            مزد روزانه
                        </td>
                        <td width="8%">
                            ماخذ بیمه
                        </td>
                        <td width="8%">
                            کل حقوق و مزایا
                        </td>
                        <td width="8%">
                            سایر کسورات
                        </td>
                        <td rowspan="2">
                            امضا
                            <br>
                            شماره حساب
                        </td>
                    </tr>
                    <tr style="background-color: rgb(245, 245, 245);">
                        <td>
                            نام و نام خانوادگی
                        </td>
                        <td>
                            شماره شناسنامه
                        </td>
                        <td>
                            کد ملی
                        </td>
                        <td>
                            کد شغل
                        </td>
                        <td>
                            تاریخ ترک کار
                        </td>
                        <td>
                            جنسیت
                        </td>
                        <td>
                            شماره بیمه
                        </td>
                        <td>
                            مزد ماهانه
                        </td>
                        <td>
                            بیمه سهم کارمند
                        </td>
                        <td>
                            مزایای مشمول
                        </td>
                        <td>
                            خالص پرداختی
                        </td>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in DataAxios.SalaryDetials " :key="index"
                    style="break-inside: avoid !important;border-bottom: 2.5px solid black;">
                    <tr>

                        <td class="">
                            {{ index + 1 }}
                        </td>
                        <td class="">
                            {{ item.FatherNmae }}
                        </td>
                        <td class="">
                            {{ item.PersonnelCode }}
                        </td>
                        <td class="">
                            <div>{{ item.Job }}</div>
                        </td>
                        <td class="">
                            {{ item.ContractStartDate }}
                        </td>
                        <td class=""><span>{{item.Nationality}}</span></td>
                        <td class="">
                            {{ item.WorkPerformanceDaily }}
                        </td>
                        <td class="">{{ $Comma3ragham(item.DailySalary) }}</td>
                        <td class="">{{ $Comma3ragham(item.SumMashmolBime) }}</td>
                        <td class="">{{ $Comma3ragham(item.SumSalaryAndBenefits) }}</td>
                        <td class="">{{ $Comma3ragham(item.MissOther) }}</td>
                        <td rowspan="2" valign="bottom" class="DotRt">
                            <br>
                        </td>
                    </tr>
                    <tr>
                        <td class="">
                            {{ item.NamFam }}
                        </td>
                        <td class="">
                            {{ item.IdCardNumber }}
                        </td>
                        <td class="">
                            {{ item.NationalCode }}
                        </td>
                        <td class="">{{ item.JobCode }} </td>
                        <td class="">
                            {{ item.ContractEndDate }}
                        </td>
                        <td class="">
                            {{ item.GenderGrp13 == 17 ? 'مرد' : 'زن' }}
                        </td>
                        <td class="">
                            {{ item.InsuranceNumber }}

                        </td>
                        <td class="">{{ $Comma3ragham(item.MonthlySalary) }}</td>
                        <td class="">{{ $Comma3ragham(item.BimeKarmand) }}</td>
                        <td class="">{{ $Comma3ragham(item.SumBenefitsBime) }}</td>
                        <td class="">{{ $Comma3ragham(item.NetPayment) }}</td>
                    </tr>
                </tbody>

                <tfoot style="background-color: rgb(245, 245, 245) !important;">
                    <tr>
                        <th colspan="6" align="left" rowspan="2">
                            جمع
                        </th>
                        <th rowspan="2">{{ $Comma3ragham(DataAxios.SumWorkPerformanceDaily) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumDailySalary) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumMashmolBime) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumKolSalaryAndBenefits) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumMissOther) }}</th>
                        <th rowspan="2"></th>
                    </tr>
                    <tr>
                        <th>{{ $Comma3ragham(DataAxios.SumMonthlySalary) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumBimeKarmand) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumKolBenefitsBime) }}</th>
                        <th>{{ $Comma3ragham(DataAxios.SumNetPayment) }}</th>
                    </tr>
                </tfoot>
            </table>
            <div class="row no-print">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            <table class="w-100" style="break-inside: avoid !important;">
                <tbody>
                    <tr>
                        <td class="p-0" style="width: 49%;">
                            <table class="table table-bordered border-dark  text-center w-100">
                                <tr>
                                    <td rowspan="5" valign="top" align="right" class="pt-2">
                                        محل مهر و امضا کارفرما
                                    </td>
                                    <th style="background-color: rgb(245, 245, 245);" colspan="2">تعداد نفرات</th>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);" width="20%">
                                        ایرانی
                                    </th>
                                    <td width="20%">
                                        {{ DataAxios.IraniNationalityCount }}
                                    </td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        غیر ایرانی
                                    </th>
                                    <td>
                                        {{ DataAxios.OtherNationalityCount }}
                                    </td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        مرد
                                    </th>
                                    <td>
                                        {{ DataAxios.MenCount }}
                                    </td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        زن
                                    </th>
                                    <td>
                                        {{ DataAxios.WomenCount }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td></td>
                        <td class="p-0" style="width: 49%;">
                            <table class="table table-bordered border-dark text-center w-100">
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);" width="60%">
                                        جمع حق بیمه سهم کارمند
                                    </th>
                                    <td width="40%">{{ $Comma3ragham(DataAxios.SumBimeKarmand) }}</td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        جمع حق بیمه سهم کارفرما
                                    </th>
                                    <td>{{ $Comma3ragham(DataAxios.SumBimeSahmeKarfarma) }}</td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        جمع حق بیمه بیکاری
                                    </th>
                                    <td>{{ $Comma3ragham(DataAxios.SumBimeBikary) }}</td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        جمع حق بیمه مشاغل سخت و زیان آور
                                    </th>
                                    <td>
                                        0.0
                                    </td>
                                </tr>
                                <tr>
                                    <th style="background-color: rgb(245, 245, 245);">
                                        جمع کل
                                    </th>
                                    <td>{{ $Comma3ragham(DataAxios.SumKolBime) }}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            DataAxios: {},
            SalaryId: 0
        }
    },
    components: {},
    beforeMount() {
        this.SalaryId = this.$route.query.SalaryId
    },
    mounted() {

        this.GetData()
    },
    methods: {

        GetPrint() {
            // window.print();
            var mywindow = window.open('', 'PRINT')

            mywindow.document.write('<html><head>')
            mywindow.document.write('<link rel="stylesheet" href="/assets/bootstrap/bootstrap.min.css"  >')
            mywindow.document.write('<link rel="stylesheet" href="/assets/iransans/font-face-Sans.css">')
            mywindow.document.write('<link rel="stylesheet" href="/assets/print/FishPrint.css">')
            mywindow.document.write('</head><body onload="window.print()" dir="rtl">')
            mywindow.document.write(document.getElementById('printableArea').innerHTML)
            mywindow.document.write('</body></html>')
            mywindow.document.close()
            mywindow.focus()
            mywindow.document.close()

        },
        GetData() {
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'SalaryReport/GetInsuranceList/' + this.SalaryId, Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if (data != null) {
                    if (data.IsSuccess == true) {
                        // console.log(data);
                        this.DataAxios = data.Data

                    }
                }
            }).finally(() => {

            });
        },
    }
}
</script>
<style scoped>
@media print {

    .no-print {
        display: none;
    }
}

* {
    font-weight: 900;
}

tr {
    color: var(--sidebar-color-item) !important;


}

table {
    background: var(--sidebar-bg-color) !important;
    color: var(--sidebar-color-item);

}


td {
    border-color: var(--table-border-color) !important;
}

th {
    font-weight: 900;
    text-align: center;
    color: var(--sidebar-color-item) !important;
    border-color: var(--table-border-color) !important;
}

thead {
    border-color: var(--table-border-color) !important;
}

tr:hover {
    color: var(--sidebar-color-item) !important;
    background: var(--sidebar-bg-color) !important;
}
</style>
    